export enum EPlatformWhatsAppConversationStage {
  New = 0,
  Qualifying = 1,
  Qualified = 2,
  DemoRequested = 3,
  TrialStarted = 4,
  Won = 5,
  Lost = 6,
}
